module.exports = __webpack_public_path__ + "static/media/optibolt-2.ae12a164.jpg";